import debounce from 'lodash.debounce';
import helperUtilities from '../../mixins/helper-utilities';

/**
 * @module
 * the control the behaviours of a single level of navigation
 */

const selector = '[data-js-nav]';
const navLevel = function (el, app) {

    const helpers = helperUtilities(app);

    const $el = $(el);
    const $inner = $el.find('[data-js-nav-inner]');
    let $children = $inner.find('.Ge-Nav-Item');
    const $subtitleOuter = $el.find('[data-js-nav-subtitle-outer]');
    let childActive = false; // the "active" nav item that the shuttle will need to move to
    let outerWidth = 0;
    let innerWidth = 0;
    let cumulativeWidth = 0;
    let firstOffset = 0;
    let subtitleOuterWidth = 0;
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth || $(window).width();
    let viewportWidthPrev = viewportWidth;
    app.navStickyStatus = false; // is the sticky menu currently in "sticky" mode?

    // the shuttle is the small green/white bar under/over the menu item that slides around based on the hover/active state
    const $shuttle = $el.find('[data-js-nav-shuttle]');

    const init = function () {
        // swap from the no-js 
        $el.addClass('Ge-Nav--js');
        // spot the active link
        findActive();
        // do the initial measurements of all widths
        measure();
        measureOffset();
        shuttleInit();
        $el.addClass('Ge-Nav--ready');
        onResize();
    };

    // measure the widths of all core components
    const measure = function () {

        // get on with the measuring
        outerWidth = $el[0].offsetWidth;
        innerWidth = $inner[0].offsetWidth;
        cumulativeWidth = 0;
        // if a subtitle exists and is displayed at this screensize:
        if ($subtitleOuter.length)
            subtitleOuterWidth = $subtitleOuter[0].offsetWidth;

        // each child link and their with as a group
        for (let i = 0; i < $children.length; i++) {
            const child = $children[i];
            $children[i].jsWidth = child.offsetWidth;
            $children[i].jsOffset = cumulativeWidth;
            cumulativeWidth += $children[i].jsWidth;
        }
    };

    // measure the offset of the first nav link (needs to be done after the priority plus shuffle is complete)
    const measureOffset = function () {
        if ($children.length) {
            firstOffset = $children[0].offsetLeft;
        }
    };

    // find the active item in this list
    const findActive = function () {
        childActive = $children.index($children.filter('.Ge-Nav-Item--active'));
    };

    // setup the hover shuttle
    const shuttleInit = function () {

        // 
        if (!$children.length) {
            return;
        }

        let timer = false;

        // move shuttle to the active child
        shuttleMove(childActive);
        // set up the hover event
        $children.on('mouseout', function shuttleInitMouseOut(event) {

            const $t = $(event.relatedTarget);
            if ($t.hasClass('Ge-Nav-Item') ||
                $t.closest('.Ge-MegaMenu').length > 0) {
                return;
            }

            // turn off the hover shuttle
            clearTimeout(timer);
            timer = setTimeout(function () {
                $el.removeClass('Ge-Nav--Hover');
                // move the hover shuttle
                shuttleMove(childActive);
            }, 200);
        });
        // set up the hover event
        $children.children('a').on('mouseover', function shuttleInitMouseOver(ev) {
            // turn on the hover shuttle
            clearTimeout(timer);
            $el.addClass('Ge-Nav--Hover');
            // move the hover shuttle
            const hoverIndex = $children.index($(this).parent());
            if (hoverIndex >= 0) { // it can return -1 if you mouse over items in the "mer" submenu - so ignore them!
                shuttleMove(hoverIndex);
            }
        });
    };

    // move the shuttle to the item of a certain index
    const shuttleMove = function (childIndex) {

        // error fallback
        if (childIndex < 0) {
            //$shuttle.remove();
            //console.warn('shuttle requested to move to index: ' + childIndex);
            //return;
            childIndex = 0;
        }
        if ($children[childIndex] === undefined) {
            return;
        }
        const newWidth = $children[childIndex].jsWidth;
        const newOffset = $children[childIndex].jsOffset;
        $shuttle.css({
            left: firstOffset + newOffset,
            width: newWidth
        });
    };

    // things need to be re-positioned when the window is resized
    const onResize = function () {

        // let   timer = false;

        const onResizeThrottled = function () {

            // do the initial measurements of all widths
            measure();
            measureOffset();
            shuttleMove(childActive);
            // ready to re-paint the menu again
            $el.addClass('Ge-Nav--ready');
        };

        // throttle resize events
        $(window).resize(function onResizeUnThrottled(ev) {
            // Don't trigger resize on vertical resize (mobile OS' do this all the time just on scroll). 
            // Note that we try and do every kind of "soft" measurement before we attempt to recalc styles (which is costly in FPS)
            viewportWidth = ev.target.innerWidth || window.innerWidth || document.documentElement.clientWidth || $(window).width();
            if (viewportWidth != viewportWidthPrev) {
                $el.removeClass('Ge-Nav--ready');
                debounce(onResizeThrottled, 500, { 'leading': false })();
            }
            viewportWidthPrev = viewportWidth;
        });

    };

    return {
        init: init()
    };
};

navLevel.selector = selector;
export default navLevel;
